import React, { Fragment } from "react";
import { PRIVACY } from "../../enums/termsAndConditions";
import { Head } from "@inertiajs/react";

const PrivacyPolicyPage = () => {
  return (
    <Fragment>
      <Head>
        <title>Privacy Policy</title>
        <meta name="description" content="Privacy Policy for WannaCollab." />
      </Head>
      {PRIVACY}
    </Fragment>
  );
};

export default PrivacyPolicyPage;